// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTechnologyMobileAlt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 5a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3zm2 14a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-.941a.904.904 0 0 0-.809.5.904.904 0 0 1-.809.5h-2.882a.904.904 0 0 1-.809-.5.905.905 0 0 0-.809-.5H8a1 1 0 0 0-1 1zm7.5-1a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTechnologyMobileAlt;
